export default "__VITE_ASSET__DDTtmpb6__"